// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app {\n  font-family: Roboto, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n::-webkit-scrollbar-track {\n  background: #e6e6e6;\n  border-left: 1px solid #dadada;\n}\n::-webkit-scrollbar-thumb {\n  background: #b0b0b0;\n  border-radius: 7px;\n}", ""]);
// Exports
module.exports = exports;
